<script setup>
import { ref, defineProps, defineEmits, onMounted, watch } from "vue";
import TreeView from "./TreeView.vue";

const props = defineProps({
  item: Object,
  rootName: String,
  expandAll: Boolean,
});

onMounted(() => {
  if (props.expandAll) {
    expanded.value = true;
  }
});

watch(
  () => props.expandAll,
  (value) => {
    expanded.value = value;
  }
);

function hasSubObjects(item) {
  let keys = Object.keys(item);
  if (keys.length > 1) {
    return true;
  }
  if (keys.length == 1) {
    if (keys[0] == "ESFevents") {
      return false;
    }
  }
  return true;
}

function getObjectKeyName(item) {
  return Object.keys(item)[0];
}

function getKeys(object) {
  var keys = Object.keys(object);
  keys = keys.filter((key) => {
    if (key == "ESFevents") {
      return false;
    }
    return true;
  });
  keys.sort();
  return keys;
}

// Traverse the object and return a count of all the ESFevents
function getESFEventCount(object) {
  let count = 0;
  if (object.ESFevents) {
    count = object.ESFevents.length;
  }
  Object.keys(object).forEach((key) => {
    if (key != "ESFevents") {
      count += getESFEventCount(object[key]);
    }
  });
  //count = count.toString();
  return count;
}

// onMounted(() => {
//   console.log("Props Item", props.item);
// });

const expanded = ref(false);
const showOverlay = ref(false);
const selectedFile = ref([]);
const selectedEvent = ref({});
const blocked = "Blocked";

function selectFile(events) {
  console.log("Select File", events);
  selectedFile.value = events;
  showOverlay.value = true;
  if (events.length > 0) {
    selectedEvent.value = events[0];
  }
}

// Check item.ESFevents for blocked events
function isBlocked(item) {
  if (item.ESFevents) {
    for (let i = 0; i < item.ESFevents.length; i++) {
      if (item.ESFevents[i].blocked) {
        return true;
      }
    }
  }
  return false;
}
</script>

<template>
  <v-dialog v-model="showOverlay" max-width="700">
    <v-card closable>
      <v-card-title
        ><v-row>
          <v-col>File Events</v-col>
          <v-spacer></v-spacer>
          <v-col cols="auto"
            ><v-icon @click="showOverlay = false">mdi-close</v-icon></v-col
          >
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="selectedEvent"
          :items="selectedFile"
          item-title="signingid"
          return-object
          label="Select Event"
        ></v-select>
        <v-row>
          <v-col>
            <v-text-field
              v-model="selectedEvent.eventtype"
              label="Event Type"
              variant="plain"
              readonly
            />
            <v-text-field
              v-model="selectedEvent.username"
              label="Username"
              variant="plain"
              readonly
            />
          </v-col>
          <v-col>
            <v-text-field
              v-model="selectedEvent.signingid"
              label="Signing ID"
              variant="plain"
              readonly
            />
            <v-text-field
              v-model="selectedEvent.target"
              label="Target File Path"
              variant="plain"
              readonly
            />
          </v-col>
          <v-col>
            <v-text-field
              v-if="selectedEvent.blocked"
              value="Blocked"
              label="Action"
              variant="plain"
              v-model="blocked"
              readonly
            />
            <v-text-field
              v-if="selectedEvent.source"
              v-model="selectedEvent.source"
              label="Source File Path"
              variant="plain"
              readonly
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>

  <tr>
    <td>
      <template v-if="hasSubObjects(props.item)">
        <v-icon @click="expanded = !expanded">{{
          expanded ? "mdi-menu-down" : "mdi-menu-right"
        }}</v-icon>

        <v-icon
          class=""
          @click="selectFile(props.item.ESFevents)"
          v-if="props.item.ESFevents.length"
          >{{
            isBlocked(props.item)
              ? "mdi-folder-cancel"
              : "mdi-folder-information"
          }}</v-icon
        >
        <v-icon v-else>mdi-folder</v-icon>
        {{ props.rootName }} ({{ getESFEventCount(props.item) }})
      </template>
      <template v-else>
        <v-icon class="ml-7" @click="selectFile(props.item.ESFevents)"
          >mdi-file</v-icon
        >{{ props.rootName }}
      </template>
      <template v-if="expanded">
        <tr v-for="object in getKeys(item)" :key="object">
          <td>
            <TreeView
              :item="item[object]"
              :rootName="object"
              :expandAll="props.expandAll"
            />
          </td>
        </tr>
      </template>
    </td>
  </tr>
</template>
